export default __webpack_public_path__ + "static/img-media-benzinga-87fc3f90f927e4536cd52442e36cb134.jpeg";